import { useEffect, useRef } from 'react'

const useSafeTimeout = () => {
  const timeouts = useRef([])

  useEffect(() => () => timeouts.current.forEach(t => clearTimeout(t)), [])

  const setSafeTimeout = (callback, delay) => {
    const timeout = setTimeout(() => {
      timeouts.current.splice(timeouts.current.indexOf(timeout, 1))
      callback()
    }, delay)
    timeouts.current.push(timeout)
    return timeout
  }

  return setSafeTimeout
}

export default useSafeTimeout
